import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import Sidebar from '@/components/layout/Sidebar';
import Header from '@/components/layout/Header';
import { useAuthStore } from '@/store/auth.store';
import { useTranslation } from 'react-i18next';
import { getDateLocale } from '@/i18n';

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const user = useAuthStore((state) => state.user);
  const { t, i18n } = useTranslation();

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  const now = new Date();
  const name = user?.displayName || user?.email?.split('@')[0] || 'User';
  const greeting = t('header.greeting', { name });
  const dateLocale = getDateLocale(i18n.language);
  const dateStr = now.toLocaleDateString(dateLocale, options);

  return (
    <div className="flex h-screen bg-gradient-to-br from-white via-neutral-50 to-neutral-100">
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-20 lg:hidden transition-opacity duration-300"
          onClick={closeSidebar}
        />
      )}

      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />

      <div className="flex-1 min-h-0 flex flex-col overflow-hidden lg:ml-72">
        <Header
          onMenuClick={toggleSidebar}
          greeting={greeting}
          date={dateStr}
        />

        <main className="flex-1 min-h-0 overflow-y-auto relative">
          <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{backgroundImage: 'radial-gradient(circle at 1px 1px, currentColor, currentColor 1px)'}}></div>
          <div className="w-full px-4 py-6 sm:px-6 sm:py-8 lg:px-8 relative z-10">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
